import { render, staticRenderFns } from "./MyAttachment.vue?vue&type=template&id=1d2d0d1a&lang=pug&"
import script from "./MyAttachment.vue?vue&type=script&lang=js&"
export * from "./MyAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports